import Lang from "@/common/Lang";
import moment from "moment/moment";
import { defineComponent, reactive, toRaw, UnwrapRef } from 'vue';

export default {
  methods: {
    convertPascalCase(title) {
      return title.replace(/(^\w|-\w)/g, function (text) {
        return text.replace(/-/, "").toUpperCase();
      });
    },
    generateRules(entity, fields) {
      let rules = {};
      for (let idx in fields) {
        let field = fields[idx];
        rules[field.name] = [];
        if (typeof field.validator != "undefined") {
          rules[field.name].push({
            validator: field.validator,
            trigger: field.trigger || "blur",
          });
        } else {
          if (typeof field.required != "undefined") {
            rules[field.name].push({
              required: true,
              message: "Vui lòng nhập " + Lang[entity].attribute[field.name],
              trigger: field.trigger || "blur",
            });
          }
          if (typeof field.min != "undefined") {
            rules[field.name].push({
              min: "Độ dài " + Lang[field.name] + " tối thiểu là " + field.min,
              max: "Độ dài " + Lang[field.name] + " tối đa là " + field.max,
              trigger: field.trigger || "blur",
            });
          }
        }
      }
      return reactive(rules);
    },
    generateFormData(config) {
      let data = {};
      const now = moment();
      for (let prop in config) {
        let element = config[prop];
        data[prop] = "";
        switch (element.dataType) {
          case "array":
            data[prop] = [];
            break;
          case "number":
            data[prop] = 0;
            if (typeof element.defaultValue != "undefined") {
              data[prop] = element.defaultValue;
            }
            break;
          case "date":
            data[prop] = null;
            if (element.defaultValue === "now") {
              let increment = element.increment || 0;
              let incrementUnit = element.incrementUnit || "days";
              data[prop] = now.clone().add(increment, incrementUnit);
            }
            break;
          case "bool":
            data[prop] = null;
            if (element.defaultValue === false) {
              data[prop] = false;
            }
            break;
          case "time":
            data[prop] = null;
            if (element.defaultValue === "now") {
              let increment = element.increment || 0;
              let incrementUnit = element.incrementUnit || "hours";
              data[prop] = now.clone().add(increment, incrementUnit);
            }
            break;
        }
        if (element.relation) {
          data[element.relation] = void 0;
        }
      }

      return reactive(data);
    },
  },
};
